<template>
  <v-container fluid>
    <v-row justify="center" align="center" fluid class="pt-6 pb-6">
      <p class="display-2 text-center font-weight-bold indigo--text">3 printmaking pieces</p>
    </v-row>
    <v-row class="amber lighten-4" fluid pt-0 pb-0 pl-0 pr-0>
      <v-col cols="8" class="pa-2" align="center">
        <v-img style="width:80%" src="@/assets/VA/PDS/Melih_Meric/lamp.png"></v-img>
        <v-img style="width:80%" src="@/assets/VA/PDS/Melih_Meric/midnight.png"></v-img>
        <v-img style="width:80%" src="@/assets/VA/PDS/Melih_Meric/pattern.jpg"></v-img>
        <v-container style="width:80%">
          <p class="text-sm-center font-weight-bold">Artist Statement</p>

          <p
            class="text-sm-left"
          >I like to combine my experience living in a city with absurd fundamentals of daily life dynamics and what I create. I find value in works that capture the essence of orientalism, the structure of the living. I work with the idea of remembrance, especially specific patterns from Turkish culture, often imitating traditional tile motifs. Using printmaking as my main medium, I enjoy works of modular nature, creating continuous abstract patterns.</p>
        </v-container>
      </v-col>
      <v-col cols="4">
        <AUTH :author="author" />
        <p class="text-sm-left">{{author.bio}}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AUTH from "../../../Article/Author.vue";
export default {
  props: ["author"],
  components: {
    AUTH
  }
};
</script>